// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

import './footer.scss';

const showRandomFooterCard = () => {
  const footerCard = document.querySelector('.footer__card');

  if (!footerCard) {
    return;
  }

  const cards = Array.from(footerCard.querySelectorAll('.card-nav'));

  if (!cards.length) {
    return;
  }

  const randomIndex = Math.floor(Math.random() * cards.length);

  cards.forEach((card, index) => {
    card.classList.toggle('card-nav--visible', index === randomIndex);
  });
};

showRandomFooterCard();
